import React, { Component } from 'react';
import { withRouter } from 'react-router';

import { ShellContext } from 'contexts/shellContext';
import PropTypes from 'prop-types';

import ConfirmModal from './ConfirmModal';
import NavigationPrompt from './NavigationPrompt';

export const renderConfirmNavigationModal = ({
  title = 'general.prevent_leave',
  ...props
}) => <ConfirmModal title={title} {...props} />;

renderConfirmNavigationModal.propTypes = {
  title: PropTypes.string
};

class ConfirmNavigation extends Component {
  static propTypes = {
    afterCancel: PropTypes.func,
    afterConfirm: PropTypes.func,
    beforeCancel: PropTypes.func,
    beforeConfirm: PropTypes.func,
    children: PropTypes.node,
    onConfirm: PropTypes.shape({
      action: PropTypes.func,
      label: PropTypes.string
    }),
    onConfirmSecondary: PropTypes.shape({
      action: PropTypes.func,
      label: PropTypes.string
    }),
    shouldConfirmNavigation: PropTypes.bool,
    history: PropTypes.object,
    match: PropTypes.object
  };

  getMergedOption = (option, onConfirmPrompt, onCancel) => {
    if (!(option && option.action)) {
      return {
        ...option,
        action: onConfirmPrompt
      };
    }

    return {
      ...option,
      action: async () => {
        try {
          const response = await option.action();

          response !== false ? onConfirmPrompt() : onCancel();
        } catch {
          onCancel();
        }
      }
    };
  };

  replaceModalConfigs = ({ onConfirmPrompt, onCancel, modalConfigs = {} }) => {
    const { onConfirm, onConfirmSecondary } = modalConfigs;

    return {
      ...modalConfigs,
      onCancel,
      onConfirm: this.getMergedOption(onConfirm, onConfirmPrompt, onCancel),
      onConfirmSecondary:
        onConfirmSecondary &&
        this.getMergedOption(onConfirmSecondary, onConfirmPrompt, onCancel)
    };
  };

  renderNavigationPrompt = ({ history, match }) => {
    const {
      afterCancel,
      afterConfirm,
      beforeCancel,
      beforeConfirm,
      shouldConfirmNavigation,
      ...modalConfigs
    } = this.props;

    if (!history || !match) {
      return null;
    }

    return (
      <NavigationPrompt
        afterCancel={afterCancel}
        afterConfirm={afterConfirm}
        beforeCancel={beforeCancel}
        beforeConfirm={beforeConfirm}
        when={shouldConfirmNavigation}
        history={history}
        match={match}
      >
        {({ onConfirm: onConfirmPrompt, onCancel }) => {
          return renderConfirmNavigationModal(
            this.replaceModalConfigs({
              onConfirmPrompt,
              onCancel,
              modalConfigs
            })
          );
        }}
      </NavigationPrompt>
    );
  };

  render() {
    const { children, shouldConfirmNavigation, history, match } = this.props;

    if (shouldConfirmNavigation) {
      return (
        <>
          <ShellContext.Consumer>
            {this.renderNavigationPrompt}
          </ShellContext.Consumer>

          {this.renderNavigationPrompt({ history, match })}

          {children}
        </>
      );
    }

    return null;
  }
}

export default withRouter(ConfirmNavigation);
